const suburbs = [
    "Abbotsford",
    "Aberfeldie",
    "Airport West",
    "Albanvale",
    "Albert Park",
    "Albion",
    "Alexandra",
    "Alfredton",
    "Alphington",
    "Altona",
    "Altona Meadows",
    "Altona North",
    "Ararat",
    "Ardeer",
    "Armadale",
    "Armstrong Creek",
    "Arthurs Seat",
    "Ascot Vale",
    "Ashburton",
    "Ashwood",
    "Aspendale",
    "Aspendale Gardens",
    "Attwood",
    "Auburn",
    "Avondale Heights",
    "Avonsleigh",
    "Bacchus Marsh",
    "Bairnsdale",
    "Badger Creek",
    "Balaclava",
    "Ballan",
    "Balnarring",
    "Balnarring Beach",
    "Balwyn",
    "Balwyn North",
    "Ballarat",
    "Ballarat East",
    "Bannockburn",
    "Bayswater",
    "Bayswater North",
    "Beaconsfield",
    "Beaconsfield Upper",
    "Beaumaris",
    "Beechworth",
    "Belgrave",
    "Belgrave Heights",
    "Belgrave South",
    "Belmont",
    "Bell Park",
    "Bellfield",
    "Benalla",
    "Bend of Islands",
    "Bendigo",
    "Bendigo North",
    "Bendigo/Junortoun",
    "Bennettswood",
    "Bentleigh",
    "Bentleigh East",
    "Berwick",
    "Beveridge",
    "Black Rock",
    "Blackburn",
    "Blackburn North",
    "Blackburn South",
    "Blind Bight",
    "Bonbeach",
    "Boneo",
    "Boronia",
    "Botanic Ridge",
    "Box Hill",
    "Box Hill North",
    "Box Hill South",
    "Braeside",
    "Braybrook",
    "Briar Hill",
    "Brighton",
    "Brighton East",
    "Broadmeadows",
    "Brookfield",
    "Brooklyn",
    "Brunswick",
    "Brunswick East",
    "Brunswick North",
    "Brunswick West",
    "Bulla",
    "Bulleen",
    "Bundoora",
    "Bungaree",
    "Bunyip",
    "Burnley",
    "Burnside",
    "Burnside Heights",
    "Burwood",
    "Burwood East",
    "Cairnlea",
    "Camberwell",
    "Camberwell East",
    "Camperdown",
    "Campbellfield",
    "Canterbury",
    "Carlton",
    "Carlton North",
    "Carnegie",
    "Casterton",
    "Castlemaine",
    "Caroline Springs",
    "Carrum",
    "Carrum Downs",
    "Caulfield",
    "Caulfield East",
    "Caulfield North",
    "Caulfield South",
    "Chadstone",
    "Charlemont",
    "Charlton",
    "Chelsea",
    "Chelsea Heights",
    "Cheltenham",
    "Chiltern",
    "Chirnside Park",
    "Churchill",
    "Clarinda",
    "Clarkes Hill",
    "Clayton",
    "Clayton South",
    "Clifton Hill",
    "Clifton Springs",
    "Clyde North",
    "Cobblebank",
    "Cobram",
    "Coburg",
    "Coburg North",
    "Coburg East",
    "Cohuna",
    "Colac",
    "Coleraine",
    "Collingwood",
    "Coragulac",
    "Corio",
    "Corryong",
    "Coolaroo",
    "Cowes",
    "Craigieburn",
    "Craigieburn West",
    "Cranbourne",
    "Cranbourne East",
    "Cranbourne North",
    "Cranbourne South",
    "Cranbourne West",
    "Cremorne",
    "Creswick",
    "Crib Point",
    "Croydon",
    "Croydon Hills",
    "Croydon North",
    "Croydon South",
    "Dallas",
    "Dandenong",
    "Dandenong North",
    "Dandenong South",
    "Daylesford",
    "Deepdene",
    "Deer Park",
    "Delacombe",
    "Delahey",
    "Dennington",
    "Derrimut",
    "Diamond Creek",
    "Dingley",
    "Dingley Village",
    "Donald",
    "Donvale",
    "Docklands",
    "Doncaster",
    "Doncaster East",
    "Donvale",
    "Doreen",
    "Doveton",
    "Drouin",
    "Drysdale",
    "Dunnstown",
    "Eaglemont",
    "Eaglehawk",
    "East Melbourne",
    "Eastern View",
    "Echuca",
    "Edenhope",
    "Edithvale",
    "Elmore",
    "Elsternwick",
    "Eltham",
    "Eltham North",
    "Elwood",
    "Emerald",
    "Endeavour Hills",
    "Epping",
    "Epping North",
    "Essendon",
    "Essendon North",
    "Essendon West",
    "Euroa",
    "Fairfield",
    "Fawkner",
    "Fawkner North",
    "Ferntree Gully",
    "Ferny Creek",
    "Fitzroy",
    "Fitzroy North",
    "Flemington",
    "Footscray",
    "Forest Hill",
    "Frankston",
    "Frankston East",
    "Frankston North",
    "Frankston South",
    "Gardenvale",
    "Geelong",
    "Geelong East",
    "Geelong West",
    "Gisborne",
    "Gladstone Park",
    "Glen Huntly",
    "Glen Iris",
    "Glen Waverley",
    "Glenroy",
    "Gordon",
    "Gowanbrae",
    "Greensborough",
    "Greensborough North",
    "Greenvale",
    "Greenvale Lakes",
    "Grovedale",
    "Hadfield",
    "Hamilton",
    "Hallam",
    "Hampton",
    "Hampton East",
    "Hampton Park",
    "Harkaway",
    "Hastings",
    "Hawthorn",
    "Hawthorn East",
    "Healesville",
    "Heathcote",
    "Heatherton",
    "Heathmont",
    "Heidelberg",
    "Heidelberg Heights",
    "Heidelberg West",
    "Herne Hill",
    "Heyfield",
    "Highett",
    "Hillside",
    "Hopetoun",
    "Hoppers Crossing",
    "Hoppers Crossing North",
    "Horsham",
    "Hughesdale",
    "Huntingdale",
    "Hurstbridge",
    "Inglewood",
    "Ivanhoe",
    "Ivanhoe East",
    "Ivanhoe West",
    "Jacana",
    "Kangaroo Flat",
    "Kealba",
    "Keilor",
    "Keilor Downs",
    "Keilor East",
    "Keilor North",
    "Keilor Lodge",
    "Keilor Park",
    "Kennington",
    "Kensington",
    "Kerang",
    "Kew",
    "Kew East",
    "Keysborough",
    "Kialla",
    "Kilmore",
    "Kilsyth",
    "Kilsyth South",
    "Kings Park",
    "Kingsbury",
    "Kingsville",
    "knightsville",
    "Knoxfield",
    "Kooyong",
    "Koo Wee Rup",
    "Koroit",
    "Korumburra",
    "Kurunjang",
    "Kyabram",
    "Kyneton",
    "Lalor",
    "Lalor West",
    "Lancefield",
    "Langwarrin",
    "Langwarrin South",
    "Lara",
    "Laverton",
    "Laverton North",
    "Leongatha",
    "Lilydale",
    "Lower Plenty",
    "Lucas",
    "Lynbrook",
    "Lyndhurst",
    "Lysterfield",
    "Macleod",
    "Maffra",
    "Maiden Gully",
    "Maidstone",
    "Malvern",
    "Malvern East",
    "Manifold Heights",
    "Manor Lakes",
    "Mansfield",
    "Maribyrnong",
    "Maryborough",
    "McKinnon",
    "Meadow Heights",
    "Melbourne",
    "Melbourne West",
    "Melbourne Airport",
    "Melton",
    "Melton South",
    "Melton West",
    "Mentone",
    "Merbein",
    "Mernda",
    "Mickleham",
    "Middle Park",
    "Mildura",
    "Mill Park",
    "Mitcham",
    "Moe",
    "Monbulk",
    "Mont Albert",
    "Mont Albert North",
    "Montmorency",
    "Montrose",
    "Moonee Ponds",
    "Moorabbin",
    "Mooroolbark",
    "Mooroopna",
    "Mordialloc",
    "Moreland",
    "Mornington",
    "Mortlake",
    "Morwell",
    "Morwell East",
    "Mount Atkinson",
    "Mount Clear",
    "Mount Duneed",
    "Mount Eliza",
    "Mount Evelyn",
    "Mount Ridley (Nth Craigieburn)",
    "Mount Waverley",
    "Mulgrave",
    "Murrumbeena",
    "Murtoa",
    "Myrtleford",
    "Nagambie",
    "Nar Nar Goon",
    "Narre Warren",
    "Narre Warren North",
    "Narre Warren South",
    "Nathalia",
    "New Gisborne",
    "Newborough",
    "Newcomb",
    "Newport",
    "Newport",
    "Newtown",
    "Nhill",
    "Niddrie", 
    "Noble Park",
    "Noble Park North",
    "Noorat",
    "Norlane",
    "North Melbourne",
    "North Warrandyte",
    "Northcote",
    "Notting Hill",
    "Numurkah",
    "Nunawading",
    "Oak Park",
    "Oakleigh",
    "Oakleigh East",
    "Oakleigh South",
    "Ocean Grove",
    "Officer",
    "Orbost",
    "Ormond",
    "Pakenham",
    "Park Orchards",
    "Parkdale",
    "Parkdale East",
    "Parkville",
    "Pascoe Vale",
    "Pascoe Vale South",
    "Penshurst",
    "Plenty",
    "Point Cook",
    "Port Fairy",
    "Portland",
    "Port Melbourne",
    "Prahran",
    "Prahran East",
    "Preston",
    "Preston East",
    "Preston West",
    "Princes Hill",
    "Quarry Hill",
    "Queenscliff",
    "Red Cliffs",
    "Redan",
    "Red Hill",
    "Red Hill South",
    "Research",
    "Reservoir",
    "Reservoir East",
    "Reservoir North",
    "Robinvale",
    "Rochester",
    "Richmond",
    "Ringwood",
    "Ringwood East",
    "Ringwood North",
    "Ripponlea",
    "Rockbank",
    "Rosanna",
    "Rosebud",
    "Rowville",
    "Roxburgh Park",
    "Rushworth",
    "Rutherglen",
    "Rye",
    "Safety Beach",
    "Sale",
    "St Albans",
    "St Andrews",
    "St Arnaud",
    "St Helena",
    "St Kilda",
    "St Kilda East",
    "St Kilda West",
    "Sandhurst",
    "Sandringham",
    "Scoresby",
    "Sassafras",
    "Scoresby",
    "Sea Lake",
    "Seabrook",
    "Seaford",
    "Seaholme",
    "Sebastopol",
    "Seddon",
    "Seymour",
    "Shepparton",
    "Shepparton North",
    "Shepparton South",
    "Skye",
    "Soldiers Hill",
    "Somerton",
    "Somerville",
    "Sorrento",
    "South Kingsville",
    "South Melbourne",
    "South Morang",
    "South Yarra",
    "Southbank",
    "Spotswood",
    "Springvale",
    "Springvale South",
    "Strathmore",
    "Strathmore Heights",
    "Sunbury",
    "Sunshine",
    "Sunshine North",
    "Sunshine West",
    "Surrey Hills",
    "Stawell",
    "Stratford",
    "Strathfieldsaye",
    "Strathmore",
    "Sunbury",
    "Sunshine North",
    "Sunshine West",
    "Swan Hill",
    "Sydenham",
    "Tallangatta",
    "Tarneit",
    "Tarneit North",
    "Tarneit West",
    "Tatura",
    "Taylors Hill",
    "Taylors Lakes",
    "Templestowe",
    "Templestowe Lower",
    "Terang",
    "The Basin",
    "Thomastown",
    "Thomastown East",
    "Thomastown West",
    "Thornbury",
    "Thornbury East",
    "Thornbury West",
    "Thornhill Park",
    "Tongala",
    "Toorak",
    "Tootgarook",
    "Torquay",
    "Torquay North",
    "Tottenham",
    "Trafalgar",
    "Traralgon",
    "Traralgon West",
    "Travancore",
    "Truganina",
    "Truganina South",
    "Tullamarine",
    "Tyabb",
    "Upper Ferntree Gully",
    "Vermont",
    "Vermont South",
    "Viewbank",
    "Wallan",
    "Wallan East",
    "Wangaratta",
    "Wantirna",
    "Wantirna South",
    "Warrandyte",
    "Warrandyte South",
    "Warracknabeal",
    "Warragul",
    "Warrnambool",
    "Warrnambool East",
    "Warrnambool West",
    "Warranwood",
    "Waterways",
    "Watsonia",
    "Watsonia North",
    "Wattle Glen",
    "Weir Views",
    "Werribee",
    "Werribee North",
    "Werribee South",
    "West Footscray",
    "West Melbourne",
    "Westmeadows",
    "Wheelers Hill",
    "White Hills",
    "Whittington",
    "Whittlesea",
    "Wildwood",
    "Williams Landing",
    "Williamstown",
    "Williamstown North",
    "Windsor",
    "Wodonga",
    "Wodonga West",
    "Wollert",
    "Wonga Park",
    "Wonthaggi",
    "Woodend",
    "Wyndham Vale",
    "Yallambie",
    "Yarra Glen",
    "Yarra Junction",
    "Yarram",
    "Yarrambat",
    "Yarraville",
    "Yarrawonga",
    "Yea"
]   

export default suburbs;
  